'use strict';

angular.module('AcaApp').factory('LayoutService',
[
  '$rootScope',
  '$timeout',
  'FORMATS',
  function($rootScope, $timeout, FORMATS){
    var htmlElement = 'html';
    var bodyElement = 'body';
    var loginPath = '/login';
    var pagesWithoutFooter = [
      '/login',
      '/forgot-password',
      '/account-locked',
      '/reset-password',
      '/create-account',
      '/license-agreement',
      '/add-phone',
      '/send-mfa'
    ];
    var pagesWithoutHeader = [
      '/login'
    ];
    var pagesWithoutHeaderOptions = [
      '/login',
      '/forgot-password',
      '/account-locked',
      '/reset-password',
      '/create-account',
      '/license-agreement',
      '/invalid-session',
      '/cliend-disabled',
      '/add-phone',
      '/send-mfa'
    ];
    var isURLInArrary = function(urlsArray, url){
      return _.find(urlsArray, function(value){
        var reg = new RegExp('^' + value + '($|\\?)');
        return reg.test(url);
      });
    };
    var checkHeaderVisibility = function(nextPath){
      if(isURLInArrary(pagesWithoutHeader, nextPath)){
        $rootScope.layoutHeader = false;
      }
      else{
        $rootScope.layoutHeader = true;
      }
    };
    var checkFooterVisibility = function(nextPath){
      if(isURLInArrary(pagesWithoutFooter, nextPath)){
        $rootScope.layoutFooter = false;
      }
      else{
        $rootScope.layoutFooter = true;
      }
    };
    var checkHeaderOptionsVisibility = function(nextPath){
      if(isURLInArrary(pagesWithoutHeaderOptions, nextPath)){
        $rootScope.layoutHeaderOptions = false;
      }
      else{
        $rootScope.layoutHeaderOptions = true;
      }
    };
    $rootScope.layoutHeader = true;
    $rootScope.layoutFooter = true;
    $rootScope.layoutHeaderOptions = true;
    return {
      setBody: function(type){
        if(type === 'left-column-gray'){
          this.setBodyClass('left-column-gray');
        }
        else{
          if(type === 'gray-bg-no-admin'){
            this.setBodyClass('gray-bg-no-admin');
          }
        }
      },
      setBodyByDefault: function(currentPath, nextPath){
        checkHeaderVisibility(nextPath);
        checkFooterVisibility(nextPath);
        checkHeaderOptionsVisibility(nextPath);
        $(bodyElement).removeClass();
        $(htmlElement).removeClass();
        if(nextPath === loginPath){
          this.setBodyClass('blue-bg');
        }
        else{
          if(currentPath === loginPath){
            this.setBodyClass('white-bg');
          }
        }
      },
      setBodyClass: function(className){
        $(bodyElement).removeClass();
        $(htmlElement).removeClass();
        $(bodyElement).attr('class', className);
        $(htmlElement).attr('class', className);
      },
      addFloatLayer: function(triggerId, layerId){
        if($rootScope[triggerId] === undefined){
          $(layerId).css({'z-index': '16777271'});
          $(layerId).hide();
          $(document).on('click', triggerId, function(event){
            event.stopPropagation();
            $(layerId).fadeToggle('fast');
          });
          $(document).on('click', function(){
            $(layerId).hide('fast');
          });
          $rootScope[triggerId] = true;
        }
      },
      selectedItemToUpperCase: function(value1, value2){
        return (value1 !== undefined) ? (value1.toUpperCase() === value2.toUpperCase()) : false;
      },
      triggerSelectBoxChange: function(){
        /* istanbul ignore next */
        $('select').trigger('change');
      },
      addDatepicker: function(component){
        /* istanbul ignore next */
        $timeout(
          function(){
            $(component).datetimepicker({
              timepicker: false,
              format: FORMATS.DATEFORMAT
            });
          }
        );
      },
      addDatepickerRangeDate: function(component){
        /* istanbul ignore next */
        $timeout(
          function(){
            $(component).datetimepicker({
              timepicker: false,
              format: FORMATS.DATEFORMAT,
              maxDate: 0
            });
          }
        );
      },
      setSelectBoxChange: function(idSelect, value, idLabel){
        $timeout(
          function(){
            $(idSelect).val(value).attr("selected", "selected");
            $(idLabel).text('');
          }
        );
      },
      formatAMPM: function(date) {
        date = new Date(date);
        var day = (date.getDate() <= 9)?'0' + date.getDate():date.getDate();
        var month = date.getMonth();
        var year = date.getFullYear();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = month+1 + '/' + day + '/' + year +  ' ' + hours + ':' + minutes + ' ' + ampm;
        return (month <= 8)? '0'+strTime:strTime;
      }
    };
  }
]);
